/* globals Class, lp, jui */
var _ = require('lodash');
var jQuery = require('jquery');
var React = require('react');
var ReactDOM = require('react-dom');
var ubBanzai = window.ubBanzai;
var AlertDialog = require('ub/ui/alert-dialog');

var EmbAutoDismiss = require('ub/ui/components/emb-auto-dismiss').default;

module.exports = Class.create(
    lp.editor.panel.ElementPropertiesPanel,
    lp.editor.panel.ElementGeometryControls,
    lp.editor.panel.ElementBackgroundControlsNew,
    lp.ModuleComponent,
    {
      type:'lp-pom-root',

      initialize: function($super) {
        $super();
        this.updatingStyles = false;
      },

      _addAutoLayoutControls: function() {
        this.autoLayoutPanel = new window.lp.editor.panel
          .AutoLayoutControl('page', this._uiBinding).view();

        this.insert(this.autoLayoutPanel);
      },

      installUI: function($super){
        $super();
        var self = this;
        this.modelChangeHandlers.push(function(e) {

          var accessor = e.data.accessor
            , value    = e.data.value;

          if (accessor === 'geometry.contentWidth') {
            self.controls.size.setValue({width:value});
          } else if (!self.updatingStyles && accessor === 'style.defaults.color') {
            self.controls.textColor.setValue(value);
          } else if (!self.updatingStyles && accessor === 'style.defaults.linkColor') {
            self.controls.linkColor.setValue(value);
          } else if (accessor === 'geometry.padding') {
            self.controls.paddingTop.setValue(
              (value && value.top) ? value.top : 0);
          }
        });

        this.focusListener = this.requestFocus.bind(this);

        this.mobilePagePanel = this.insert(new jui.CollapsiblePanel({
          title: 'Mobile View',
          attributes: {
            className: 'collapsible-panel panel-root-mobileview'
          }
        }));

        if(window.editor.page.getConfigValue('allowAutoLayout')){
          this._addAutoLayoutControls();
        }

        this.geometryPanel = this.insert(new jui.CollapsiblePanel({
          title: 'Geometry',
          attributes: {
            className: 'collapsible-panel panel-root-geometry'
          }
        }));

        ReactDOM.render(
          React.createElement(EmbAutoDismiss, {editor: window.editor}),
          this.insert(document.createElement('div'))
        );

        this.controls.size = this.geometryPanel.insertContent( new jui.FormSizeInput({
          label      : 'Size',
          onblur     : function(juiEvent) {
            var oldSize = juiEvent.data.memorizedSize;
            var newWidth = juiEvent.source.getValue().width;
            if (oldSize.width !== newWidth) {
              juiEvent.data.memorizedSize.width = newWidth;
              self._uiBinding.onNext({
                type  : 'changeWidth',
                width : parseInt(newWidth, 10)
              });
            }
          },
          onfocus    : this.focusListener,
          hideHeight : true
        }));

        this.controls.breakpointSize = this.geometryPanel.insertContent( new jui.FormTextInput({
          label       : 'Breakpoint',
          readonly    : true,
          attributes  : {
            className : 'form-elm breakpoint-size breakpoint-input'
          }
        }));

        this.controls.multiBreakpointToggle = new jui.FormCheckboxInput({
          attributes: {
            className: 'form-elm checkbox-input multi-line-label'
          },
          label: '<strong>Show Mobile Version to Visitors</strong>' +
            '<span class="note">Note: Uncheck when your mobile version' +
            ' is not ready to be seen by your visitors.</span>',
          inputId: 'multi-breakpoint-toggle-checkbox',
          onclick: function(juiEvent) {
            self._uiBinding.onNext({
              type    : 'changeMultipleBreakpointsVisibility',
              visible : juiEvent.source.getValue()
            });
          }
        });

        this.mobilePagePanel.insert(this.controls.multiBreakpointToggle);

        this.addListener('breakpointChanged', this.handleBreakpointControlsVisibility.bind(this));

        this.controls.paddingTop = this.geometryPanel.insertContent( new jui.FormNumericInput({
          label   : 'Top Margin',
          onfocus : this.requestFocus.bind(this),
          onblur  : function(juiEvent) {
            var newVal = juiEvent.source.getValue();
            if (newVal !== juiEvent.source.memorizedValue) {
              self._uiBinding.onNext({
                type       : 'changeTopMargin',
                paddingTop : parseInt(newVal, 10)
              });
            }
          }
        }));

        var textDefaults = this.insert(new jui.CollapsiblePanel({
          title:'Default Text Style',
          attributes: {
            className: 'collapsible-panel panel-root-text'
          }
        }));

        this.controls.textColor = textDefaults.insert( new jui.FormColorInput ({
          label   : 'Text Color',
          onblur  : function(juiEvent) {
            var newVal = juiEvent.source.getValue();
            if (newVal !== juiEvent.source.memorizedColor) {
              self._uiBinding.onNext({
                type      : 'changeDefaultTextColor',
                textColor : newVal
              });
            }},
          onfocus : this.requestFocus.bind(this)
        }));

        this.controls.linkColor = textDefaults.insert( new jui.FormColorInput ({
          label   : 'Link Color',
          onblur  : function(juiEvent) {
            var newVal = juiEvent.source.getValue();
            if (newVal !== juiEvent.source.memorizedColor) {
              self._uiBinding.onNext({
                type      : 'changeDefaultLinkColor',
                linkColor : newVal
              });
            }},
          onfocus : this.requestFocus.bind(this)
        }));

        this.titleAndMeta = this.insert(new jui.CollapsiblePanel({
          title       : 'Title & Meta Data',
          attributes  : {
            className : 'collapsible-panel meta-data panel-root-meta-data'
          }
        }));

        var metaStyleOverride = 'min-height: 48px; resize : vertical; overflow-x: hidden; overflow-y: auto';
        this.controls.title = this.titleAndMeta.insert(new jui.FormDynamicContenteditable({
          label      : 'Title',
          inputStyle : metaStyleOverride,
          className  : 'help-button tip-dtr-title',
          onfocus    : this.requestFocus.bind(this),
          onblur     : this.metaDataChanged.bind(this),
          //onkeyup    : this.metaDataChanged.bind(this)
          uiBinding : this._uiBinding.mkNamespacedVersion('TitleDTR')
        }));

        this.controls.keywords = this.titleAndMeta.insert(new jui.FormDynamicContenteditable({
          label      : 'Keywords',
          inputStyle : metaStyleOverride,
          className  : 'help-button tip-dtr-keywords',
          onfocus    : this.requestFocus.bind(this),
          onblur     : this.metaDataChanged.bind(this),
          //onkeyup    : this.metaDataChanged.bind(this)
          uiBinding : this._uiBinding.mkNamespacedVersion('KeywordsDTR')
        }));

        this.controls.description = this.titleAndMeta.insert(new jui.FormDynamicContenteditable({
          label      : 'Description',
          inputStyle : metaStyleOverride,
          className  : 'help-button tip-dtr-desc',
          onfocus    : this.requestFocus.bind(this),
          onblur     : this.metaDataChanged.bind(this),
          //onkeyup    : this.metaDataChanged.bind(this)
          uiBinding : this._uiBinding.mkNamespacedVersion('DescriptionDTR')
        }));

        this.controls.noRobots = this.titleAndMeta.insert(new jui.FormCheckboxInput({
          label: '<strong>Hide my page from search engines</strong><span class="note">Note: '+
            'make sure this is set the same for all variants</span>',
          inputId: 'no-robots-checkbox',
          onclick: this.metaDataChanged.bind(this)
        }));

        this.controls.mobilePageCheckbox = this.advancedPanel.insert(new jui.FormCheckboxInput({
          label: 'Include "viewport" meta tag for mobile.',
          inputId: 'mobile-page-checkbox',
          onclick: function(juiEvent) {
            self._uiBinding.onNext({
              type    : 'changeMobileViewportFlag',
              include : juiEvent.data
            });
          }
        }));

        this.backgroundPanel = this.insert(new jui.CollapsiblePanel({
          title:'Background Properties',
          attributes: {
            className: 'collapsible-panel panel-root-background'
          }
        }));

        this.installBackgroundControls({
          insert        : this.backgroundPanel.insertContent.bind(this.backgroundPanel),
          showFixed     : true,
          showStretched : true
        });

        this.controls.$deletePage =
          jQuery('<div class="page-delete-button"><span>Delete</span> <span class="svg-ico-delete"></span></div>')
            .hide()
            .appendTo(this.e)
            .click(this._confirmDeletePage.bind(this));

        var uiEventHandlers = {
          changeWidth: function(ev, model, um) {
            var v = ev.width;
            if (v < 16) {
              v = 16;
            }
            model.set('geometry.contentWidth', v, um);
            self.controls.size.setValue({width:v});
          },

          changeTopMargin: function(ev, model, um){
            model.set('geometry.padding', {
              left  : 'auto',
              right : 'auto',
              top   : ev.paddingTop
            }, um);
            self.controls.paddingTop.setValue(ev.paddingTop);
          },

          changeMetaData: function(ev /*, model, um */) {
            self.setMetaData(ev.metadata);
          },

          changeDefaultTextColor: function(ev, model, um) {
            model.set('style.defaults.color', ev.textColor, um);
            self.controls.textColor.setValue(ev.textColor);
          },

          changeDefaultLinkColor: function(ev, model, um) {
            model.set('style.defaults.linkColor', ev.linkColor, um);
            self.controls.linkColor.setValue(ev.linkColor);
          },

          changeMobileViewportFlag: function(ev /*, model , um */) {
            if (ev.include) {
              self.element.page.settings.mobilePage = true;
            } else {
              delete self.element.page.settings.mobilePage;
            }
            self.controls.mobilePageCheckbox.setValue(!!ev.include);
          },

          changeMultipleBreakpointsVisibility: function(ev /*, model, um */) {
            self.setMultiBreakpointToggle(ev.visible);
            self.handleMobilePageToggleControlVisibility();
            self.controls.multiBreakpointToggle.setValue(!!ev.visible);
          },

          renamePage: function(ev) {
            var name = ev.name;
            var page = self.element.page;

            if (name !== page.name && ! _.isEmpty(name)) {
              page.name = name;
            }

            self._syncPageTitle();
          },

          deletePage: function() {
            window.editor.deletePage(self.element.page);
          }
        };

        this._uiBinding.subscribe(function(ev){
          var handler = uiEventHandlers[ev.type]
            , um      = self.element.page.undoManager;

          if (typeof handler === 'function') {
            um.startGroup();
            self.performModelUpdates(function() {
              handler(ev, self.element.model, um);
            });
            um.endGroup();
          } else {
            lp.errorNotifier.captureMessage('Invalid page setting event type: '+ev.type);
          }
        });
      },

      setMultiBreakpointToggle: function(newValue) {
        var page     = this.element.page
          , oldValue = !!page.settings.multipleBreakpointsVisibility;

        if (newValue !== oldValue) {
          window.editor.pages.each(function updateMultipleBreakpointVisibility(subPage){
            subPage.settings.multipleBreakpointsVisibility = newValue;
          });
        }
      },

      metaDataChanged: function() {
        var page = this.element.page
          , newValues = {
              title       : this.controls.title.getValue(),
              keywords    : this.controls.keywords.getValue(),
              description : this.controls.description.getValue(),
              noRobots    : this.controls.noRobots.getValue()
            };

        // Check if the values have changed and if not, don't send the event to rxUi
        var valuesHaveChanged = _.some(['title', 'keywords', 'description'], function(key) {
          return newValues[key] !== page.metaData[key];
        }) || newValues.noRobots !== Boolean(page.settings.noRobots);

        if (valuesHaveChanged) {
          this._uiBinding.onNext({
            type     : 'changeMetaData',
            metadata : newValues
          });
        }
      },

      setMetaData: function(newValues) {
        var page = this.element.page
          , self = this;

        this.element.page.undoManager.registerUndo({
          action   : this.setMetaData,
          receiver : this,
          params   : [{
            title: page.metaData.title,
            keywords: page.metaData.keywords,
            description: page.metaData.description,
            noRobots: !!page.settings.noRobots
          }]
        });

        // Update metadata
        _.forEach(['title', 'keywords', 'description'], function(key) {
          page.metaData[key] = newValues[key];
        });

        // Update settings
        page.settings.noRobots = newValues.noRobots;

        // Ensure controls are in sync with the new values
        _.forEach(['title', 'keywords', 'description', 'noRobots'], function(key) {
          if (self.controls[key].getValue() !== newValues[key]) {
            self.controls[key].setValue(newValues[key]);
          }
        });
      },

      textDefaultsChanged: function() {
        this.updateTextDefaults();
      },

      updateTextDefaults: function() {
        var page      = this.element.page
          , textColor = this.controls.textColor.getValue()
          , linkColor = this.controls.linkColor.getValue()
          , um        = page.undoManager;

        this.updatingStyles = true;

        um.startGroup();
        this.element.model.set('style.defaults.color', textColor, um);
        this.element.model.set('style.defaults.linkColor', linkColor, um);
        um.endGroup();

        this.updatingStyles = false;
      },

      syncUIControls: function($super, elm) {
        $super(elm);
        var page = elm.page;

        this.titleAndMeta.setVisible(page !== null && page.allowTitleAndMetadata());

        var width = page.getCurrentBreakpoint().width || '';
        this.controls.breakpointSize.setValue(width);

        var minWidth = page.getMinWidthForCurrentBreakpoint();
        var maxWidth = page.getMaxWidthForCurrentBreakpoint();

        this.controls.multiBreakpointToggle.setValue(page.settings.multipleBreakpointsVisibility);

        this.handleMultiBreakpointToggleControlVisibility();

        this.handleMobilePageToggleControlVisibility();
        this.controls.size.options.minWidth = minWidth;
        this.controls.size.options.maxWidth = maxWidth;

        this.controls.size.setValue({width:elm.model.get('geometry.contentWidth')});

        this.controls.paddingTop.setValue(elm.model.exists('geometry.padding.top') ? elm.model.get('geometry.padding.top') : 0);
        this.controls.paddingTop.setVisible(page.allowTopPadding());

        this.controls.breakpointSize.setVisible(
          page.isMobileBreakpoint() &&
          ! page.getConfigValue('useDesktopWidthAsCSSBreakpoint')
        );

        if (window.editor.page.getConfigValue('allowAutoLayout')) {
          this.autoLayoutPanel.setVisible(page.allowAutoLayout());
        }

        this.controls.title.setValue(page.metaData.title);
        this.controls.keywords.setValue(page.metaData.keywords);
        this.controls.description.setValue(page.metaData.description);
        this.controls.noRobots.setValue(!!page.settings.noRobots);

        this.controls.mobilePageCheckbox.setValue(!!page.settings.mobilePage);

        this.controls.size.width.disabled = this.isWidthDisabled(minWidth, maxWidth);

        if (this.element.page.allowRootBackground()) {
          this.backgroundPanel.show();
          this.bindBackgroundControlsToElement(elm);
        } else {
          this.backgroundPanel.hide();
        }

        this.controls.textColor.setValue(elm.model.exists('style.defaults.color') ? elm.model.get('style.defaults.color') : '000');
        this.controls.linkColor.setValue(elm.model.exists('style.defaults.linkColor') ? elm.model.get('style.defaults.linkColor') : '00f');

        this.controls.$deletePage.toggle(page.isLightbox());

        this._syncPageTitle();
      },

      _syncPageTitle: function() {
        var $title = jQuery(this.title).html(
          jQuery('<span>')
            .addClass('page-name ellipsis')
            .html(this.element.page.getUsedAsText())
        );

        if (this.element.page.isLightbox()) {
          var $renameButton =
            jQuery('<span>')
              .addClass('edit-label-action svg-ico-edit')
              .html('Edit')
              .click(this._activatePageTitleRename.bind(this));

          $title
            .addClass('has-edit')
            .dblclick(this._activatePageTitleRename.bind(this))
            .append($renameButton);
        } else {
          $title.off('dblclick');
        }
      },

      _activatePageTitleRename: function(){
        var self = this;

        if (this.element.page.isLightbox()) {
          var $renameField =
            jQuery('<input type="text" class="rename-page" maxlength=30 value="' + this.element.page.name + '"/>')
              .on('focus', function onFocus() {
                // We need to clear the focus because we are not using a JUI component. If we
                // don't do this we'll have issues with some of the keys not working such as
                // backspace and delete key.
                window.editor.keyController.clearFocus();
              })
              .on('keydown blur', function onChange(e) {
                if (e.keyCode === Event.KEY_RETURN || e.type === 'blur') {
                  self._uiBinding.onNext({
                    type : 'renamePage',
                    name : e.target.value.stripScripts().trim()
                  });
                }
              });

          jQuery(this.title).html($renameField);

          $renameField
            .focus()
            .select();
        }
      },

      handleMultiBreakpointToggleControlVisibility: function() {
        this.mobilePagePanel.setVisible(this.isMultiBreakpointToggleVisible());
      },

      isMultiBreakpointToggleVisible: function() {
        var page = this.element.page;

        return page.isMobileBreakpoint() &&
          page.isMain() &&
          !ubBanzai.features.isNewBreakpointToggleEnabled();
      },

      handleMobilePageToggleControlVisibility: function() {
        this.controls.mobilePageCheckbox.setVisible(this.isMobilePageCheckboxVisible());
      },

      isMobilePageCheckboxVisible: function(){
        var page = this.element.page;
        if (page === null) { return; }

        return page.isMain() &&
          !page.isMobileEnabled() &&
          !page.isMobileBreakpoint() &&
          page.getConfigValue('allowViewportMetaTag');
      },

      handleBreakpointControlsVisibility: function() {
        this.handleMultiBreakpointToggleControlVisibility();
        this.handleMobilePageToggleControlVisibility();
      },

      isWidthDisabled: function(minWidth, maxWidth) {
        var page = this.element.page;
        return ( ! page.isMain() && page.isMobileBreakpoint()) ||
          (minWidth === maxWidth);
      },

      _confirmDeletePage: function() {
        var page = this.element.page;
        var self = this;

        if (page && page.isLightbox()) {
          new AlertDialog({
            title            : "Delete '" + page.name + "'?",
            message          : 'Are you sure you want to delete \'' + page.name + '\'? All ' +
              'content on the lightbox will be lost.',
            icon             : 'error',
            confirmLabel     : 'OK',
            onConfirm        : function() {
              self._uiBinding.onNext({
                type      : 'deletePage',
                pageRefId : page.getRefId()
              });
            },
            showCancelButton : true
          }).safeOpen();
        }

      }
    }
  );



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-root/root_element_properties_panel.js
// module id = 1080
// module chunks = 0